"use client";
import React, { useState, useEffect } from "react";

import Header from "../components/Header";
import TransactionCard from "../components/transaction/TransactionCard";
import AccountLayout from "../layout/AccountLayout";
import CircularProgress from "../components/transaction/CircularProgress";
import { RiWalletLine, RiMoreLine } from "@remixicon/react";
import AddMoney from "../components/transaction/AddMoney";
import { fetchTransactionByUser } from "./../api/transactionApi";
import { fetchGold } from "./../api/userApi";

import { useSelector } from "react-redux";
import Loading from "../components/common/Loading";
import ToastService from "../services/ToastService";

function WalletPage() {
  const user = useSelector((state) => state.user.user);
  const [amount, setAmount] = useState(0);
  const [isLoadingTransaction, setLoadingTransaction] = useState(true);

  const [transactions, setTransactions] = useState([]);

  const fetchTransactions = async () => {
    try {
      const data = await fetchTransactionByUser({ userId: user && user.guid });

      if (data) {
        setTransactions(data);
        setLoadingTransaction(false);
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  const fetchGoldUI = async () => {
    try {
      const data = await fetchGold({ userId: user && user.guid });

      if (data) {
        setAmount(data.gold);
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchGoldUI();
    fetchTransactions();
  }, []);

  return (
    <>
      <AccountLayout>
        <h2>Ví của bạn</h2>
        <div className=" rounded-3xl p-6 shadow-lg mb-4 background-wallet">
          {/* <button className="w-[50%] border m-auto block border-blue-400 text-rose-400 py-3 rounded-xl hover:bg-blue-50 bg-white transition mb-4">
            + Nạp tiền vào ví
          </button> */}
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-center gap-4">
              <div className="text-blue-400">
                <RiWalletLine size={48} />
              </div>
              <div>
                <p className="text-lg font-medium ">
                  Hạng: <span>Gold</span>
                </p>

                <h1 className="text-4xl font-bold">{amount} Coin</h1>
              </div>
            </div>
          </div>
        </div>
        <AddMoney />
        <br />
        <h2>Lịch sử giao dịch</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {isLoadingTransaction ? (
            <Loading />
          ) : (
            transactions &&
            transactions.map((transaction) => (
              <TransactionCard
                id={transaction.id}
                transactionCode={transaction.TransactionCode}
                paymentType={transaction.paymentType}
                description={transaction.description}
                status={transaction.status}
                amount={transaction.amount}
                bankName={transaction.bankName}
                accountNumber={transaction.accountNumber}
                isPaid={transaction.isPaid}
                isCanceled={transaction.isCanceled}
                qrCodeUrl={transaction.qrCodeUrl}
                created={transaction.created}
                paid={transaction.paid}
                canceled={transaction.canceled}
                paymentLink={transaction.paymentLink}
              />
            ))
          )}
        </div>
      </AccountLayout>
    </>
  );
}

export default WalletPage;
